const getters = {
  user: state => state.user.userinfo,
}
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js